import { Box, Typography, makeStyles, Theme } from '@material-ui/core';
import { Check } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: 300,
    padding: theme.spacing(4, 2),
    border: `1px dashed ${theme.palette.grey[300]}`,
    borderRadius: 8,
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#E3F6E8',
    marginBottom: theme.spacing(2.5),
  },
  icon: {
    color: '#2E7D32',
    fontSize: 28,
  },
  title: {
    fontWeight: 700,
    fontSize: '1.125rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
}));

export const UnclassifiedDocumentsEmptyState = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.iconCircle}>
        <Check className={classes.icon} />
      </Box>
      <Typography className={classes.title}>
        No unclassified documents
      </Typography>
      <Typography className={classes.subtitle}>
        Every document uploaded through chat has been classified. There's nothing to review right now.
      </Typography>
    </Box>
  );
};
